// extracted by mini-css-extract-plugin
export default {"price":"Ypa-z","onSale":"Zpa-z","msrpLabelPrice":"_pa-z","msrpLabel":"aqa-z","originalPrice":"bqa-z"};